import { checkAccess } from "helpers/auth";
import { ROUTE404 } from "constants/routes";
import DefaultPage from "./container/DefaultPage";

export default function getDefaultRoute(userAuth) {
  const requireAuth = {};
  return {
    path: ROUTE404,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withAppBar: true,
    withSidebar: true,
    component: DefaultPage,
  };
}
